import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SectionHistoryDriverCentralComponent } from './section-history-driver-central.component';
import { DriverCentralDetailsModalModule } from './driver-central-details-modal/driver-central-details-modal.module';

@NgModule({
  declarations: [SectionHistoryDriverCentralComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    DriverCentralDetailsModalModule,
  ],
  exports: [SectionHistoryDriverCentralComponent],
})
export class SectionHistoryDriverCentralModule {}
